export default __webpack_public_path__ + "static/MD_SearchThumb_Cloud_Recordings-94d663fcb6e066b02ae881b0f2659e3a.webp";